import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import isEmpty from 'lodash/isEmpty';

import { getLegalPolicyListService, getPolicyByEnumService } from '../../services/LegalAPI';
import { toastNotify } from '../../utils/toastNotify';

const initialState = {
  policyTypesList: [],
  policyDetails: null,
};

export const getPolicyTypes = createAsyncThunk(`GET_POLICY_TYPES`, async (_, { rejectWithValue }) => {
  try {
    const response = await getLegalPolicyListService();
    return response;
  } catch (error) {
    throw rejectWithValue(error);
  }
});

export const getPolicyByEnum = createAsyncThunk('GET_POLICY_BY_ENUM', async (title, { rejectWithValue }) => {
  try {
    const response = await getPolicyByEnumService(title);
    return response;
  } catch (error) {
    throw rejectWithValue(error);
  }
});

const legalSlice = createSlice({
  name: 'legalSlice',
  initialState,
  reducers: {
    resetPolicies: (state) => {
      state.policyTypesList = [];
    },
    resetPolicyDetails: (state) => {
      state.policyDetails = null;
    },
  },
  extraReducers: (builder) => {
    // Get Policy Types
    builder
      .addCase(getPolicyTypes.fulfilled, (state, { payload }) => {
        if (!payload?.data?.isError) {
          const { policyList } = payload?.data?.data;
          state.policyTypesList = [...policyList];
        }
      })
      .addCase(getPolicyTypes.rejected, (state, { payload }) => {
        toastNotify('error', payload?.response?.data?.message ?? 'Something went wrong.');
      });

    // Get Policy Type Details
    builder
      .addCase(getPolicyByEnum.fulfilled, (state, { payload }) => {
        if (!payload?.data?.isError && !isEmpty(payload?.data?.data)) {
          state.policyDetails = payload?.data?.data ?? null;
        } else {
          state.policyDetails = null;
          if (payload?.data?.message !== "No Data found.") {
            toastNotify('error', payload?.data?.message ?? 'Something went wrong.');
          }
          
        }
      })
      .addCase(getPolicyByEnum.rejected, (state, { payload }) => {
        toastNotify('error', payload?.response?.data?.message ?? 'Something went wrong.');
      });
  },
});

export const { resetPolicies, resetPolicyDetails } = legalSlice.actions;

export default legalSlice.reducer;
